module.exports = __webpack_public_path__ + "static/media/tablets2.27801d22.png";